import { occFetch, occUrl } from "~/app/api/occ/occFetch";

interface ApiData {
  affiliateId: string;
  salesPartnerId?: string;
}

export const apiSavePreferredPartner = (data: ApiData) => {
  return occFetch(occUrl("/partner/savePartner"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });
};
export const apiDeletePreferredPartner = () =>
  occFetch(occUrl("/partner/deletePartner"), {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
    },
  });
